import React, { useRef } from "react";
import useFlipReorder from "../hooks/useFlipReorder";
import { formatCurrency } from "../utils/format";

// Top 3 in podiumvolgorde: 2e links, 1e midden, 3e rechts.
const podiumOrder = [1, 0, 2];

const Podium = ({ rankList }) => {
  // Staafhoogte relatief aan de nummer 1; de ondergrens staat in CSS.
  const topPrice = rankList.length
    ? Math.max(...rankList.slice(0, 3).map((user) => user.totalPrice || 0))
    : 0;

  const barHeight = (price) =>
    !topPrice || !price ? 0 : Math.round((price / topPrice) * 100);

  // Treden op naam gekoppeld, zodat de FLIP-laag een wissel kan animeren.
  const podiumRef = useRef(null);
  const order = podiumOrder.map((index) => rankList[index]?.name || "-").join("|");
  useFlipReorder(podiumRef, order);

  return (
    <div className="podium podium--fill rank-swap" ref={podiumRef}>
      {podiumOrder.map((index, position) => {
        // Lege treden tonen een streepje.
        const user = rankList[index];
        const height = user ? barHeight(user.totalPrice) : 0;
        const flipKey = user ? `seller:${user.name}` : `empty:${position}`;

        return (
          <div
            key={flipKey}
            data-flip-key={flipKey}
            className={`pod pod-${index + 1}${user ? "" : " pod-empty"}`}
          >
            <div
              className="pod-bar"
              data-name={user ? user.name : undefined}
              style={{ height: `${height}%` }}
            >
              <div className="pod-label">
                <div className="n">{user ? user.name : "-"}</div>
                <div className="v">€{formatCurrency(user ? user.totalPrice : 0)}</div>
              </div>
              <div className="p">{index + 1}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Podium;
